module.exports = __webpack_public_path__ + "static/img/download-tip-text.3a245ef5.jpg";